<template>
    <div id="agencyAdd">
        <v-layout wrap row mb-1>
        <v-flex md6 style="min-height:70px;">
          <v-btn fab left to="/admin/families" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
           </v-flex>
      </v-layout>
      <v-form ref="agencyAdd">
        <v-container>
          <v-layout wrap class="px-2">
              <v-flex xs12 sm6 md6 pl-0>
                <!--  -->
              </v-flex>
              <v-flex xs12 sm6 md6 class="button-container pr-0 text-xs-right hidden-xs-only">
                <div class="d-inline-flex" v-if="selectedData">
                  <v-btn class="pf-btn pf-btn-cancel" to="/admin/families">
                    <v-icon size="16" class="pr-1">cancel</v-icon>
                    <div>Cancel</div>
                  </v-btn>
                  <v-btn class="pf-btn pf-btn-save" @click="save">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Save</div>
                  </v-btn>
                </div>
              </v-flex>
          </v-layout>
          <v-layout wrap class="pb-4 pt-3">
            <v-flex xs12 sm6 md4>
              <v-text-field v-model.trim="newAgency.name" :rules="[v => !!v || 'Name is required']" label="Name"
              class="required px-2" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-select @change="changedData" v-model="newAgency.type" :items="agencyTypes" label="Type" class="required px-2"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4 v-if="newAgency.type === 'Adoption Agency'">
              <v-select @change="changedData" multiple small-chips deletable-chips v-model="newAgency.feature_settings" :items="agencyFeatures" label="Services" class="required px-2"></v-select>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field @blur="duplicateEmailChecking" placeholder="user@example.com" :success-messages="this.emailFlag ? 'email is available': ''" v-model.trim="newAgency.email[0].email" :rules="[emailRules]" label="Admin email"
              class="required px-2" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field 
                v-mask="'(###) ###-####'"
                placeholder="(xxx) xxx-xxxx"
                label="Phone number" 
                v-model="newAgency.phone[0].number" 
                @input="changedData" 
                :rules="[rules.phoneRules]"
                class="px-2">
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field @blur="duplicateUserNameChecking" :success-messages="this.usernameFlag ? 'username is available': ''" browser-autocomplete="new-username" v-model.trim="newAgency.username" :rules="[v => !!v || 'Username is required']" label="Username"
              class="required px-2" @input="changedData"></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md4>
              <v-text-field ref="password"
                browser-autocomplete="new-password"
                autocomplete="off"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="enterPasswordRules"
                :type="show1 ? 'text' : 'password'"
                @click:append="show1 = !show1"
                @input="changedData"
                class="required px-2 pb-4"
                hint="At least 8 characters, please remember your password"
                persistent-hint
                label="Password"
                placeholder="Password"
                v-model="newAgency.password"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="pb-4 pt-3 flex-column">
            <h3 class="ml-2 pf-font-16 font-weight-bold">Address</h3>
            <v-layout wrap>
              <v-flex xs12 sm4>
                <v-text-field label="Address Line 1" v-model.trim="newAgency.address[0].line_1" class="px-2" @input="changedData"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Address Line 2" v-model="newAgency.address[0].line_2" @input="changedData" class="px-2"></v-text-field>
              </v-flex>
              <v-flex class="xs12 sm4">
                <v-text-field 
                  label="City" 
                  class="px-2" 
                  v-model.trim="newAgency.address[0].city"
                  @input="changedData">
                </v-text-field>
              </v-flex>
              <v-flex class="xs12 sm4">
                <v-autocomplete
                  label="Country" 
                  class="px-2"
                  item-text="name"
                  item-value="id"
                  :items="Country" 
                  v-model="newAgency.address[0].country" 
                  @change="changedData($event, 'Country')">
                </v-autocomplete>
              </v-flex>
              <v-flex class="xs12 sm4">
                  <v-autocomplete
                  label="State" 
                  :items="filteredData" 
                  item-value="id"
                  item-text="name"
                  :no-data-text="alertMessage"
                  class="px-2" 
                  @change="changedData($event, 'State')" 
                  v-model="newAgency.address[0].state">
                </v-autocomplete>
              </v-flex>
              <v-flex class="xs12 sm4">
                <v-text-field 
                  label="Zip Code" 
                  v-mask="'######'"
                  placeholder="xxxxx"
                  v-model="newAgency.address[0].zip" 
                  class="px-2"
                  :rules="[rules.zipRules]"
                  @input="changedData">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-container>
      <v-container>
        <v-layout wrap class="px-2">
          <v-flex xs12 sm6 md6 pl-0></v-flex>
          <v-flex xs12 sm6 md6 class="button-container pr-0 text-xs-right" v-if="selectedData">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" to="/admin/families">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      </v-form>
    </div>
  </template>
  
<script>
/* global session store */
import { getCollection, request } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import generatePassword from 'generate-password';
import { mask } from 'vue-the-mask';

export default {
  name: 'agencyAdd',
  directives: { mask },
  data: () => ({
    selectedData: true,
    usernameFlag: false,
    emailFlag: false,
    show1: false,
    newAgency: {
      name: '',
      type: 'Adoption Agency',
      feature_settings: ['FamilyManagement'],
      address: [{
        line_1: '',
        line_2: '',
        city: '',
        country: '5f0af2eb1b61360afbb1aa0c',
        state: '',
        zip: ''
      }],
      email: [{
        email: ''
      }],
      phone: [{
        country_code: '',
        number: ''
      }],
      username: '',
      password: '',
      status: 'Active'
    },
    agencyFeatures: ['FamilyManagement'],
    agencyTypes: ['Adoption Agency', 'Adoption Attorney', 'Adoption Services'],
    rules: {
      required: value => !!value || 'Field is required.',
      zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
      phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
      // websiteRules: [
      //   (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
      //   v => !v || vm.checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
      // ]
    },
    rulesPswd: [
      v => !!v || 'Password is required'
    ],
    emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please enter valid email address',
  }),
  computed: {
    ...mapGetters(['Agency']),
    filteredData () {
      let countryId = this.newAgency.country ? this.newAgency.country : '5f0af2eb1b61360afbb1aa0c';
      this.alertMessage = countryId ? 'No data available' : 'Please select country before state';
      let options = this.State;
      return options.filter(o => o.country.id === countryId);
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    }, 
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    },
    enterPasswordRules () {
      return [
        v => !!v || 'Field is required.',
        v => !!v && v.length >= 8 || 'Password cannot be less than 8 characters',
        v => /(?=.*?[A-Z])/.test(v) || 'Password must have upper case letter',
        v => /(?=.*?[0-9])/.test(v) || 'Password must have one number'
      ];
    },
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.initializeCountry();
    this.initializeState();
    this.newAgency.password = generatePassword.generate({
      length: 8,
      uppercase: true,
      numbers: true,
      lowercase: true,
      strict: true
    });
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    async initializeCountry () {
      if (!this.Country.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('Country', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Country = data;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
          }
        }
      }
    },
    async duplicateEmailChecking () {
      if (this.newAgency.email[0].email && !(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/).test(this.newAgency.email[0].email.trim())) {
        swal.fire({
          title: 'Please enter a valid email address',
          type: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Close',
          allowOutsideClick: false
        });
        return false;
      }
      this.emailFlag = false;
      if (this.newAgency.email[0].email.length) {
        let where = { 'email.email': this.newAgency.email[0].email.trim() };
        const response = await getCollection('Agency', true, 0, '', where);
        if (response.error) {
          console.log(response.error);
        } else {
          if (response.data && response.data.length) {
            swal.fire({
              title: 'The email already exists',
              type: 'error',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Close',
              allowOutsideClick: false
            }).then((result) => {
              this.newAgency.email[0].email = '';
            });
          } else {
            this.emailFlag = true;
          }
        }
      }
    },
    async duplicateUserNameChecking () {
      this.usernameFlag = false;
      if (this.newAgency.username.length) {
        let where = { 'username': this.newAgency.username.trim() };
        const response = await getCollection('User', true, 0, '', where);
        if (response.error) {
          console.log(response.error);
        } else {
          if (response.data && response.data.length) {
            swal.fire({
              title: 'The username already exists',
              type: 'error',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'Close',
              allowOutsideClick: false
            }).then((result) => {
              this.newAgency.username = '';
            });
          } else {
            this.usernameFlag = true;
          }
        }
      }
    },
    async save () {
      if (this.$refs.agencyAdd.validate()) {
        // Delete the state field from address if not selected
        this.newAgency.address = this.newAgency.address.map(address => {
          if (!address.state) {
            delete address.state;
          }
          return address;
        });
        let response = await request('Agency/Register', 'POST', this.newAgency);
        if (response.error) {
          this.newAgency.firstname2 = '';
          this.newAgency.lastname2 = '';
          swal.fire({
            type: 'warning',
            title: '<b>Error</b>',
            html: response.message || response.error,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        } else {
          swal.fire({
            type: 'success',
            title: '<b>Success</b>',
            html: 'The agency was created successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/admin/agencies', query: { requestFrom: 'save' }});
            }
          });
        }
      }
    },
    changedData (event, changedList = 'None') {
      if (changedList === 'Country') {
        this.newAgency.state = '';
      }
      this.selectedData = true;
    }
  }
};
</script>
  
<style lang="css" scoped>

  .button-container{
    min-height: 60px;
  }
  .account-type{
    padding-top: 2px;
  }
  .switch-account{
    padding-top: 5px;
  }

  .switch-cover {
    cursor: pointer;
    float:left;
  }
  .switch-cover input {
      position: absolute;
      opacity: 0;
  }
  .checkmark {
      background-color: #eff0f4;
      padding: 6px 20px;
  }
  .switch-cover:hover input ~ .checkmark {
    background-color: #ccc;
  }
  .switch-cover input:checked ~ .checkmark {
    background-color: #019d8c;
    color: #fff;
  }
  .switch-cover input:checked ~ .checkmark:after {
    display: block;
  }
  @media(max-width:410px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
    .pf-btn{
      min-width: 85px;
    }
  }
  @media(min-width: 600px) and (max-width:699px){
    .switch-account{
      padding-right: 0 !important;
      width: 100%;
      padding-bottom: 15px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/Agencies/add.vue